export enum EstadoAutorizacion {
    Pendiente,
    Aprobado,
    Rechazado
}